import React from "react";
import { Box, Typography } from "@mui/material";
import { T, EmptyNote } from "./PlatformAnalyticsShared";

// Lightweight horizontal funnel: each stage is a bar whose width is relative
// to the first (top) stage, with the stage's drop-off vs the first shown.
const FunnelChart = ({ stages = [], color = T.primary }) => {
  if (!stages.length || (stages[0]?.count ?? 0) === 0) return <EmptyNote />;
  const top = stages[0].count || 1;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {stages.map((stage, i) => {
        const pct = Math.max(2, Math.round((stage.count / top) * 100));
        const conv = i === 0 ? 100 : Math.round((stage.count / top) * 100);
        return (
          <Box key={stage.stage}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
              <Typography sx={{ fontSize: 12, fontFamily: "Segoe UI Semibold, sans-serif, system-ui", color: T.fg }}>
                {stage.stage}
              </Typography>
              <Typography sx={{ fontSize: 12, fontFamily: "Segoe UI Regular, sans-serif, system-ui", color: T.dim }}>
                {stage.count}{i > 0 && ` · ${conv}%`}
              </Typography>
            </Box>
            <Box sx={{ height: 28, borderRadius: "6px", backgroundColor: "hsl(140 8% 93%)", overflow: "hidden" }}>
              <Box
                sx={{
                  height: "100%",
                  width: `${pct}%`,
                  backgroundColor: color,
                  opacity: 1 - i * 0.13,
                  borderRadius: "6px",
                  transition: "width 400ms ease",
                }}
              />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default FunnelChart;
